import React from 'react';

/**
 * Central icon path definitions.
 * Each entry has a viewBox and a paths function that returns JSX elements.
 * This is the single source of truth — edit icons here only.
 */
export const ICON_DEFS = {
  stethoscope: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <path d="M19,8C19.56,8 20,8.43 20,9A1,1 0 0,1 19,10C18.43,10 18,9.55 18,9C18,8.43 18.43,8 19,8M2,2V11C2,13.96 4.19,16.5 7.14,16.91C7.76,19.92 10.42,22 13.5,22A6.5,6.5 0 0,0 20,15.5V11.81C21.16,11.39 22,10.29 22,9A3,3 0 0,0 19,6A3,3 0 0,0 16,9C16,10.29 16.84,11.4 18,11.81V15.41C18,17.91 16,19.91 13.5,19.91C11.5,19.91 9.82,18.7 9.22,16.9C12,16.3 14,13.8 14,11V2H10V5H12V11A4,4 0 0,1 8,15A4,4 0 0,1 4,11V5H6V2H2Z" fill={c}/>
    ),
  },

  person: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <circle cx="12" cy="7" r="4" stroke={c} strokeWidth="2"/>
        <path d="M5.5 21a6.5 6.5 0 0 1 13 0" stroke={c} strokeWidth="2" strokeLinecap="round"/>
      </>
    ),
  },

  family: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <path d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z" fill={c}/>
    ),
  },

  lock: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <rect x="5" y="11" width="14" height="10" rx="2" stroke={c} strokeWidth="2"/>
        <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke={c} strokeWidth="2" strokeLinecap="round"/>
        <circle cx="12" cy="16" r="1.5" fill={c}/>
      </>
    ),
  },

  globe: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <circle cx="12" cy="12" r="9" stroke={c} strokeWidth="2"/>
        <path d="M12 3c0 0-4 3.5-4 9s4 9 4 9M12 3c0 0 4 3.5 4 9s-4 9-4 9" stroke={c} strokeWidth="2"/>
        <path d="M3 12h18" stroke={c} strokeWidth="2" strokeLinecap="round"/>
      </>
    ),
  },

  eye: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7z" stroke={c} strokeWidth="2" strokeLinejoin="round"/>
        <circle cx="12" cy="12" r="3" stroke={c} strokeWidth="2"/>
      </>
    ),
  },

  device: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <path d="M23,11H18A1,1 0 0,0 17,12V21A1,1 0 0,0 18,22H23A1,1 0 0,0 24,21V12A1,1 0 0,0 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16A2,2 0 0,0 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2Z" fill={c}/>
    ),
  },

  wave: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <path d="M7.5 15.5V6a1.5 1.5 0 0 1 3 0v5" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.5 10.5V5a1.5 1.5 0 0 1 3 0v5.5" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.5 10.5V6.5a1.5 1.5 0 0 1 3 0v5" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.5 11.5V9a1.5 1.5 0 0 1 3 0v5.5a7 7 0 0 1-7 7h-1a7 7 0 0 1-5.5-2.7L4.2 16a1.5 1.5 0 0 1 2.1-2.1l1.2 1.6" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </>
    ),
  },

  check: {
    viewBox: '0 0 14 14',
    paths: (c) => (
      <path d="M2.5 7.5l3 3 6-6.5" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    ),
  },

  warning: {
    viewBox: '0 0 24 24',
    paths: (c) => (
      <>
        <path d="M12 2L2 20h20L12 2z" stroke={c} strokeWidth="2" strokeLinejoin="round"/>
        <path d="M12 9v5" stroke={c} strokeWidth="2" strokeLinecap="round"/>
        <circle cx="12" cy="17" r="1" fill={c}/>
      </>
    ),
  },
};
